import {
  jb_chevron_icon_css_default
} from "./chunk.NKZ5TRV2.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.IIVCI7D3.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-chevron-icon/jb-chevron-icon.ts
var JbChevronIcon = class extends Icon(r) {
  constructor() {
    super(...arguments);
    this.direction = "right";
    this.disabled = false;
    this.forceHover = false;
  }
  render() {
    return ke`
      <svg
        class="${this.direction || "right"} ${this.disabled ? "disabled" : ""} ${this.forceHover ? "hover" : ""}"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.3013 8.41088C12.6273 8.73626 12.6272 9.26376 12.3013 9.58911L6.82477 15.056C6.49884 15.3813 5.9704 15.3814 5.64445 15.056C5.31849 14.7306 5.31852 14.2031 5.64445 13.8777L10.5308 9L5.64445 4.12225C5.31849 3.79688 5.31852 3.26937 5.64445 2.94402C5.97038 2.61867 6.49881 2.61864 6.82477 2.94402L12.3013 8.41088Z"
        />
      </svg>
    `;
  }
};
JbChevronIcon.styles = [reset_css_default, jb_chevron_icon_css_default];
__decorateClass([
  n()
], JbChevronIcon.prototype, "direction", 2);
__decorateClass([
  n({ type: Boolean })
], JbChevronIcon.prototype, "disabled", 2);
__decorateClass([
  n({ type: Boolean })
], JbChevronIcon.prototype, "forceHover", 2);
JbChevronIcon = __decorateClass([
  customElement("jb-chevron-icon")
], JbChevronIcon);

export {
  JbChevronIcon
};
